import React from 'react'
import Icons from '../../../../base_components/Icons'; 
import icons from './icons.svg'

export default (props) => <Icons {...props} icons={icons} />
